import {
  Card, CardContent, Container, Divider, Typography, BottomNavigation, BottomNavigationAction, Paper, Box
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PullToRefresh } from 'react-js-pull-to-refresh';
import { connect } from 'react-redux';
import Page from 'src/components/Page';
import {
  getUndatedTasksRequest, resetDefects, resetLabours, resetMaterials
} from '../../store/actions';
import AtananIsler from '../Overview/UndatedAssignedJob';
import Header from '../Overview/Header';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import ChatIcon from '@material-ui/icons/Chat';
import ChromeReaderModeIcon from '@material-ui/icons/ChromeReaderMode';
import ScheduleIcon from '@material-ui/icons/Schedule';
import ReportIcon from '@material-ui/icons/Report';
import HourglassFullIcon from '@material-ui/icons/HourglassFull';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import TodayIcon from '@material-ui/icons/Today';
import { useHistory } from 'react-router';
import BottomRouters from 'src/components/BottomRouters';
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(1)
  },
  statistics: {
    marginTop: theme.spacing(3)
  },
  AtananIsler: {
    marginTop: theme.spacing(1)
  },
  projects: {
    marginTop: theme.spacing(6)
  },
  todos: {
    marginTop: theme.spacing(6)
  },
  content: {
    padding: 0,
    minHeight: 430,
  },
}));



const UndatedWorkOrder = (props) => {
  const classes = useStyles();
  const { t } = useTranslation('overview');
  const [value, setValue] = useState(0);
  const history = useHistory();
  const {
    getUndatedTasksRequest, resetDefects, resetLabours, resetMaterials, undatedtasks
  } = props;

  useEffect(() => {
    getUndatedTasksRequest();
    resetLabours();
    resetDefects();
    resetMaterials();
    // eslint-disable-next-line
  }, []);

  const AtananIslerData = undatedtasks.tasks;
  const handleRefresh = () => {
    getUndatedTasksRequest();
    resetLabours();
    resetDefects();
    resetMaterials();
  };

  const onRefresh = () => new Promise((resolve) => {
    setTimeout(resolve, 150);
    getUndatedTasksRequest();
  });



  return (
    <Page className={classes.root} title={'Sirius Tech'}>
      <Container maxWidth="lg">
          <Header AtananIsler={AtananIslerData} title={t('lblBookingRequiredTitle')}/>
        <PullToRefresh
          pullDownContent={<CircularProgress status="loading" style={{ marginLeft: '45%' }} />}
          releaseContent={<CircularProgress status="loading" style={{ marginLeft: '45%' }} />}
          refreshContent={<CircularProgress status="loading" style={{ marginLeft: '45%' }} />}
          pullDownThreshold={100}
          onRefresh={onRefresh}
          triggerHeight={500}
          startInvisible
        >

          <div style={{ minHeight: 400, textAlign: 'center' }}>
            {(AtananIslerData !== '')
              ? <AtananIsler className={classes.AtananIsler} AtananIsler={AtananIslerData} handleRefresh={handleRefresh} />
              : (
                <div>
                  <Divider />
                  <Card>
                    <CardContent className={classes.content}>
                      <Typography variant="h5" gutterBottom>
                        <br />
                        <br />
                          {t('undatedAppointment')}
                      </Typography>
                    </CardContent>
                  </Card>
                </div>
              )}

          </div>
        </PullToRefresh>
        <br />
        <br />
        <br />
        <br />
        <br />
        <Paper style={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }} elevation={2}>
            <BottomNavigation
            showLabels
            value={value}
            onChange={(event, newValue) => {

              setValue(newValue);
              if (newValue === 0) {
                history.push('/MaterialOrder/Create/ForPartner');
              }
              if (newValue === 1) {
                history.push('/PendingJobs');
              }
              if (newValue === 2) {
                history.push('/MaterialNeed');
              }
              if (newValue === 3) {
                history.push('/UndatedWorkOrder');
              }
            }}
          >
            <BottomNavigationAction label={t('lblActionRequired')} icon={<ReportIcon />} />
            <BottomNavigationAction label={t('lblAwaitingPreOrder')} icon={<HourglassFullIcon />} />
            <BottomNavigationAction label={t('lblPartsDelivery')} icon={<LocalShippingIcon />} />
            <BottomNavigationAction label={t('lblUndatedWorkOrder')} icon={<TodayIcon />} />
          </BottomNavigation>
        </Paper>
        <BottomRouters/>
      </Container>
    </Page>
  );
};
export default connect(
  (state) => ({ undatedtasks: state.tasks1 }),
  {
    getUndatedTasksRequest, resetDefects, resetLabours, resetMaterials
  }
)(UndatedWorkOrder);
